import { styled } from '@mui/material/styles';

type StyledButtonProps = {
  'data-is-active': boolean;
};

export const StyledButton = styled('button')<StyledButtonProps>(({ theme, ...props }) => ({
  border: props['data-is-active'] ? `0.1rem solid ${theme.colors.base01}` : `0.1rem solid ${theme.colors.base05}`,

  width: '100%',

  borderRadius: '0.8rem',

  color: theme.colors.base01,
  backgroundColor: theme.colors.base08,

  padding: '0',

  textAlign: 'left',

  '&:hover': {
    opacity: 0.8,
    border: `0.1rem solid ${theme.colors.base01}`,
  },

  cursor: 'pointer',
}));

export const ContentContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  padding: '1.8rem 2.4rem',
});

export const ContentLeftContainer = styled('div')({
  height: '2.4rem',

  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center',

  columnGap: '0.6rem',
});

export const ContentLeftTextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  color: theme.colors.base01,
}));

export const ContentRightImageContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
